
import { fetch } from '@/services/base'

const paramsTransformer = ({
  fromDate, toDate, supervisors, acos, customers, zones, jobTypes, processes
}) => (
  {
    toDate: toDate || undefined,
    fromDate: fromDate || undefined,
    supervisor: (supervisors && supervisors.length) ? supervisors.join(',') : undefined,
    aco_username: (acos && acos.length) ? acos.join(',') : undefined,
    zone: (zones && zones.length) ? zones.join(',') : undefined,
    customer: (customers && customers.length)  ? customers.join(',') : undefined,
    typeSinister: (jobTypes && jobTypes.length) ? jobTypes.join(',') : undefined,
    processes: (processes && processes.length) ? processes.join(',') : undefined
  }
)

/**
 * Fetches sinister count by Cycle and Process
 * @return {Promise} An http GET request
 */
const fetchSinisters = (filters = {}) => {
  return fetch('totals/macro_process', {
    urlGroup: 'sinister',
    config: {
      params: paramsTransformer(filters)
    }
  })
}

export default fetchSinisters
